import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	groupByButton: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-button',
		defaultMessage: 'Group',
		description: 'Group by button text',
	},
	groupByActiveButtonAriaLabel: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-aria-label',
		defaultMessage: 'Group by {label}',
		description: 'Accessibility label for the group by button',
	},
	groupByActiveButtonOld: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button-old',
		defaultMessage: 'Group by: {groupByFieldId}',
		description: 'Group by button text with grouping applied',
	},
	groupByActiveButton: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-active-button',
		defaultMessage: 'Group: {groupByFieldId}',
		description: 'Group by button text with grouping applied',
	},
	groupByAssignee: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-assignee',
		defaultMessage: 'Assignee',
		description: 'Label for group by button that groups items by assignee',
	},
	groupByStatus: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-status',
		defaultMessage: 'Status',
		description: 'Label for group by button that groups items by status',
	},
	groupByPriority: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-priority',
		defaultMessage: 'Priority',
		description: 'Label for group by button that groups items by priority',
	},
	groupByCategory: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-category',
		defaultMessage: 'Category',
		description: 'Label for group by button that groups items by category',
	},
	groupByStoryPoints: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-points',
		defaultMessage: 'Story points',
		description: 'Label for group by button that groups items by Story points',
	},
	groupByStoryPointEstimate: {
		id: 'business-list.list-view.header-actions.group-by-dropdown.trigger.group-by-story-point-estimate',
		defaultMessage: 'Story point estimate',
		description: 'Label for group by button that groups items by Story points estimate',
	},
});
